import * as $ from "jquery";

export default class OrderImportComponent {
    constructor() {
        this.componentSelector = "#cutters-order-import";
        this.token = null;
    }

    init() {
        if ($(this.componentSelector).length === 0) return;

        $('#cutters-import-preview').off().on('click', () => this.preview());
        $('#cutters-import-execute').off().on('click', () => this.execute());
        $(this.componentSelector).off('click.orderImport', '#cutters-import-new').on('click.orderImport', '#cutters-import-new', () => window.location.reload());
    }

    preview() {
        const file = $('#cutters-import-file')[0].files[0];
        if (!file) return;

        const data = new FormData();
        data.append('file', file);

        $.ajax({
            url: '/OrderImport/Preview',
            type: 'POST',
            data: data,
            processData: false,
            contentType: false
        }).done((result) => {
            this.token = result.Token;
            this.renderPreview(result);
            $('#cutters-import-execute').prop('disabled', !result.IsValid);
        });
    }

    execute() {
        if (!window.confirm('Skapa fakturaordrar f\u00f6r samtliga validerade salonger?')) return;

        $.post('/OrderImport/Execute', { token: this.token }).done((result) => {
            this.renderResult(result);
            $('#cutters-import-form, #cutters-import-actions').hide();
        });
    }

    renderPreview(result) {
        let html = '';
        (result.Errors || []).forEach((error) => {
            html += '<div class="alert alert-danger"><strong>Kan inte importera:</strong> ' + this.escape(error) + '</div>';
        });

        if ((result.Orders || []).length) {
            html += '<h3 class="cutters-import-preview-title">F&ouml;rhandsgranskning <small>' + result.Orders.length + ' fakturaordrar</small></h3>';
            html += '<div class="table-responsive"><table class="table table-striped table-hover cutters-import-preview-table">';
            html += '<thead><tr><th>Marknad</th><th>Salong / kundnummer</th><th>Artiklar</th><th class="text-right">Antal artiklar</th><th>Status</th></tr></thead><tbody>';
            (result.Orders || []).forEach((order) => {
                const articles = (order.Lines || []).map((line) =>
                    '<div><strong>' + this.escape(line.Sku) + '</strong> <span class="text-muted">&times; ' + line.Quantity + '</span></div>'
                ).join('');
                const status = order.Error
                    ? '<span class="label label-danger">Kan inte skapas</span><div class="text-danger small" style="margin-top: 6px;">' + this.escape(order.Error) + '</div>'
                    : '<span class="label label-success">Klar att skapa</span>';

                html += '<tr>'
                    + '<td><span class="label label-default">' + this.escape(this.marketName(order.MarketId)) + '</span></td>'
                    + '<td><strong>' + this.escape(order.CustomerNumber) + '</strong></td>'
                    + '<td>' + articles + '</td>'
                    + '<td class="text-right">' + (order.Lines || []).length + '</td>'
                    + '<td>' + status + '</td>'
                    + '</tr>';
            });
            html += '</tbody></table></div>';
        } else if (!(result.Errors || []).length) {
            html += '<div class="alert alert-info">Inga orderrader med Order volume &ouml;ver noll hittades i filen.</div>';
        }

        $('#cutters-import-result').html(html);
    }

    renderResult(result) {
        const orders = result.Orders || [];
        const created = orders.filter((order) => !!order.OrderNumber).length;
        const failed = orders.length - created;
        let html = '<div class="alert alert-success"><h3 style="margin-top: 0;">Importen &auml;r klar</h3>';
        html += '<p style="margin-bottom: 0;">' + created + ' av ' + orders.length + ' fakturaordrar skapades.';
        if (failed) html += ' ' + failed + ' ' + (failed === 1 ? 'order' : 'ordrar') + ' kunde inte skapas.';
        html += '</p></div>';
        html += '<h3>Importresultat</h3><div class="table-responsive"><table class="table table-striped table-hover">';
        html += '<thead><tr><th>Marknad</th><th>Salong / kundnummer</th><th>Ordernummer</th><th class="text-right">Artiklar</th><th>Status</th></tr></thead><tbody>';
        orders.forEach((order) => {
            const success = !!order.OrderNumber;
            const status = success
                ? '<span class="label label-success">Skapad</span>'
                : '<span class="label label-danger">Misslyckades</span>';
            html += '<tr>'
                + '<td><span class="label label-default">' + this.escape(this.marketName(order.MarketId)) + '</span></td>'
                + '<td><strong>' + this.escape(order.CustomerNumber) + '</strong></td>'
                + '<td>' + this.escape(order.OrderNumber || '–') + '</td>'
                + '<td class="text-right">' + (order.Lines || []).length + '</td>'
                + '<td>' + status + (order.Error ? '<div class="text-danger small" style="margin-top: 6px;">' + this.escape(order.Error) + '</div>' : '') + '</td>'
                + '</tr>';
        });
        html += '</tbody></table></div>';
        html += '<div class="btn-toolbar" style="margin-top: 20px;">';
        html += '<a class="btn btn-primary" href="/OrderImport/DownloadResult?token=' + encodeURIComponent(this.token) + '"><i class="fa fa-file-excel-o" aria-hidden="true" style="margin-right: 6px;"></i>Ladda ned resultat som Excel</a>';
        html += '<button type="button" class="btn btn-default" id="cutters-import-new" style="margin-left: 8px;"><i class="fa fa-plus" aria-hidden="true" style="margin-right: 6px;"></i>Ny import</button>';
        html += '</div>';
        $('#cutters-import-result').html(html);
    }

    marketName(marketId) {
        return { 1: 'SE', 2: 'DK', 3: 'NO', 4: 'FI' }[marketId] || 'Ok\u00e4nd';
    }

    escape(value) {
        return $('<div>').text(value || '').html();
    }
}
